import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../../Loader";
import ListInfo from "../../BookModule.module.css";
import CustomDownloadButton from "../../../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { R_PER_PAGE } from "../../../../../../labels";
import Pagination from "../../../../../ReusuableComponent/Pagination/Pagination";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ViewIcon from "./ViewIcon.png";
import { Search } from "@mui/icons-material";
import { AxiosInstance } from "../../../../../../axios";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import DatePickerSample from "../../../../DatePicker";
import {
  clearBookFilters,
  setBookFilters,
} from "../../../../../../redux/purchaseBookFilterSlice";
import toast from "react-hot-toast";

export default function ListPreOrder() {
  const navigate = useNavigate();
  const { active_tab } = useParams();
  // List data load table
  let page = R_PER_PAGE;
  let filterSearch = [];
  let filterAvalible_to_user = [];
  let filterCategory = [];
  let filterCourse = [];
  let filterSubject = [];
  let filterMedium = [];
  let filterSeries = [];
  let filterApplyeds = [];
  const filterRef_avaliable_to_user = useRef(null);
  const filterRef_category = useRef(null);
  const filterRef_course = useRef(null);
  const filterRef_subject = useRef(null);
  const filterRef_medium = useRef(null);
  const filterRef_series = useRef(null);
  const txtBSearch = useRef(null); //search icon
  const txtBSearch_course = useRef(null); //search icon
  const txtBSearch_subj = useRef(null); //search icon
  const tDatePickerRef = useRef(null);
  const filterLastRef = useRef(null);
  const fDatePickerRef = useRef(null);
  const filterRef_mrp = useRef(null);
  // use state
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [updateChipData, setUpdateChipData] = useState([]);

  const [updateListData, setUpdateListData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  const [categoryId, setCategoryId] = useState([]);
  const [courseId, setCourseId] = useState([]);
  const [subjectId, setSubjectId] = useState([]);
  const [courseIds, setCourseIds] = useState([]);
  const [subjectIds, setSubjectIds] = useState([]);
  const [available_to_user, setAvailable_to_user] = useState([]);
  const [category_on, setCategory_on] = useState([]);
  const [course_on, setCourse_on] = useState([]);
  const [subject_on, setSubject_on] = useState([]);
  const [medium_on, setMedium_on] = useState([]);
  const [series_on, setSeries_on] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [appOns, setAppOns] = useState([]);
  const [appDatas, setAppDatas] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [initialfields, setInitialfields] = useState({
    fromPrice: "",
    toPrice: "",
  });
  const Tagsitems = [
    {
      tag_id: 0,
      tag_name: "A",
    },
    {
      tag_id: 1,
      tag_name: "B",
    },
    {
      tag_id: 2,
      tag_name: "GB",
    },
    {
      tag_id: 3,
      tag_name: "QB",
    },
    {
      tag_id: 4,
      tag_name: "PYQ",
    },
    // {
    //   tag_id: 6,
    //   tag_name: "Combo Offers",
    // },
  ];
  const [isOpen, setIsOpen] = useState({
    available_to_user: false,
    category: false,
    course: false,
    subject: false,
    medium: false,
    seriesTag: false,
    startDates: false,
    price: false,
  });

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  useEffect(() => {
    filterCategory = category_on;
  }, [category_on]);

  useEffect(() => {
    filterCourse = course_on;
  }, [course_on]);
  useEffect(() => {
    filterSubject = subject_on;
  }, [subject_on]);
  useEffect(() => {
    filterMedium = medium_on;
  }, [medium_on]);

  useEffect(() => {
    filterAvalible_to_user = available_to_user;
  }, [available_to_user]);
  useEffect(() => {
    filterSeries = series_on;
  }, [series_on]);
  useEffect(() => {
    filterApplyeds = appOns;
  }, [appDatas]);
  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);
  const handleChange = (event) => {
    let { name, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };
  const handleClick = () => {
    navigate("/studyMaterials/Books/CreatePreOrder");
    dispatch(clearBookFilters());
  };
  const filters = useSelector((state) => state.listBookFilter);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);

  const locations = useLocation();
  const {
    fillCate,
    fillCourse,
    fillSub,
    fillMedium,
    fillSearch,
    filSeries,
    filDate,
    filPrice,
  } = locations.state || {};

  useEffect(() => {
    if (fillCate && fillCate.length > 0) {
      setCategory_on(fillCate);
      filterCategory = fillCate;
    } else {
      setCategory_on(category_on);
      filterCategory = category_on;
    }
    if (fillCourse && fillCourse.length > 0) {
      setCourse_on(fillCourse);
      filterCourse = fillCourse;
    } else {
      setCourse_on(course_on);
      filterCourse = course_on;
    }
    if (fillSub && fillSub.length > 0) {
      setSubject_on(fillSub);
      filterSubject = fillSub;
    } else {
      setSubject_on(subject_on);
      filterSubject = subject_on;
    }
    if (fillMedium && fillMedium.length > 0) {
      setMedium_on(fillMedium);
      filterMedium = fillMedium;
    } else {
      setMedium_on(medium_on);
      filterMedium = medium_on;
    }
    if (filSeries && filSeries.length > 0) {
      setSeries_on(filSeries);
      filterSeries = filSeries;
    } else {
      setSeries_on(series_on);
      filterSeries = series_on;
    }
    if (filPrice && (filPrice.fromPrice || filPrice.toPrice)) {
      setInitialfields(filPrice);
    } else {
      setInitialfields({ fromPrice: "", toPrice: "" });
    }

    if (filDate && filDate.length > 0) {
      const filterDates = filDate[0];
      setAppDatas({
        FDate: filterDates.fdate,
        TDate: filterDates.edate,
        Days: filterDates.Days,
        name: "",
      });
      setAppOns(filDate);
      filterApplyeds = filDate;
    }

    if (fillSearch && fillSearch.length > 0) {
      filterSearch = [{ name: "" + fillSearch, type: "search" }];
      setSearchTerm(fillSearch);
    } else {
      if (searchTerm) {
        // setSearchTerm(status);
        filterSearch = [{ name: "" + searchTerm, type: "search" }];
      }
    }
    setIsFiltersInitialized(true);
    loadChipdata(filPrice);
  }, []);

  useEffect(() => {
    if (isFiltersInitialized && fillCate && fillCate.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && fillCourse && fillCourse.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && fillSub && fillSub.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && fillMedium && fillMedium.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && fillSearch && fillSearch.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && filDate && filDate.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && filPrice && filPrice.length > 0) {
      loadListdata();
    }
  }, [
    fillCate,
    fillCourse,
    fillSub,
    fillMedium,
    fillSearch,
    filDate,
    fillSearch,
    filSeries,
    filPrice,
    isFiltersInitialized,
    updateChipData,
  ]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, updateChipData]);
  // useEffect(() => {
  //   const dateFormat = {
  //     FDate: filters.date[0]?.fdate,
  //     TDate: filters.date[0]?.edate,
  //     Days: filters.date[0]?.edate,
  //     name: filters.date[0]?.name,
  //   };
  //   // Ensure filters are set up before making API calls
  //   setCategory_on(filters.category || []);
  //   setCourse_on(filters.course || []);
  //   setSubject_on(filters.subject || []);
  //   setMedium_on(filters.medium || []);
  //   setSeries_on(filters.seriesTag || []);
  //   setAppOns(filters.date || []);
  //   setAppDatas(dateFormat || []);
  //   setSearchTerm(filters.searchTerm || []);
  //   setInitialfields(filters.price || {});
  //   setIsFiltersInitialized(true); // Mark filters as initialized

  //   const allFilters = [
  //     ...(filters.author || []),
  //     ...(filters.publisher || []),
  //     ...(filters.visibleToUser || []),
  //     ...(filters.category || []),
  //     ...(filters.course || []),
  //     ...(filters.subject || []),
  //     ...(filters.medium || []),
  //     ...(filters.seriesTag || []),
  //     ...(filters.eBook || []),
  //     ...(filters.freeBook || []),
  //     ...(filters.date || []),
  //     ...(filters.price?.fromPrice && filters.price?.toPrice
  //       ? [
  //         {
  //           name: `${filters.price.fromPrice} - ${filters.price.toPrice}`,
  //           type: "price",
  //         },
  //       ]
  //       : []),
  //     ...(typeof filters.searchTerm === "string" &&
  //       filters.searchTerm.trim() !== ""
  //       ? [{ name: filters.searchTerm, type: "search" }]
  //       : []),
  //   ];
  //   setUpdateChipData(allFilters);
  // }, [filters]);

  // useEffect(() => {
  //   if (
  //     isFiltersInitialized &&
  //     filters &&
  //     Object.keys(filters).some((key) => filters[key]?.length > 0)
  //   ) {
  //     loadListdata();
  //   }
  // }, [JSON.stringify(filters), isFiltersInitialized, updateChipData]);
  // useEffect(() => {
  //   if (isFiltersInitialized && filters) {
  //     loadListdata();
  //   }
  // }, [JSON.stringify(filters), isFiltersInitialized, updateChipData]);

  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          setCategoryId(res.data.data);
        } else {
          setCategoryId([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);

  const currentData = updateListData?.slice(start, end);

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();
      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleFilterCourseSearch = (event, names) => {
    if (names == "course") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = courseId.filter(
          (item) =>
            item.course_name &&
            item.course_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setCourseIds(matchingObjects);
      } else {
        setCourseIds(courseId);
      }
    } else if (names == "subject") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = subjectId.filter(
          (item) =>
            item.subject_name &&
            item.subject_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setSubjectIds(matchingObjects);
      } else {
        setSubjectIds(subjectId);
      }
    }
  };

  const handleFilterSearchFocus = (name) => {
    if (name == "course") {
      if (txtBSearch_course.current) {
        txtBSearch_course.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_course.current.dispatchEvent(event);
      }
    } else if (name == "subject") {
      if (txtBSearch_subj.current) {
        txtBSearch_subj.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_subj.current.dispatchEvent(event);
      }
    }
  };

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "category") {
      if (checked) {
        setCategory_on([
          ...category_on,
          { id: value, name: name, type: "category" },
        ]);
      } else {
        setCategory_on(category_on.filter((item) => item.id !== value));
      }
    } else if (typename === "course") {
      if (checked) {
        setCourse_on([...course_on, { id: value, name: name, type: "course" }]);
      } else {
        setCourse_on(course_on.filter((item) => item.id !== value));
      }
    } else if (typename === "subject") {
      if (checked) {
        setSubject_on([
          ...subject_on,
          { id: value, name: name, type: "subject" },
        ]);
      } else {
        setSubject_on(subject_on.filter((item) => item.id !== value));
      }
    } else if (typename === "medium") {
      if (checked) {
        setMedium_on([...medium_on, { id: value, name: name, type: "medium" }]);
      } else {
        setMedium_on(medium_on.filter((item) => item.id !== value));
      }
    } else if (typename === "available_to_user") {
      if (checked) {
        setAvailable_to_user([
          ...available_to_user,
          { id: value, name: name, type: "availableToUser" },
        ]);
      } else {
        setAvailable_to_user(
          available_to_user.filter((item) => item.id !== value)
        );
      }
    } else if (typename === "seriesTag") {
      if (checked) {
        setSeries_on([
          ...series_on,
          { id: value, name: name, type: "seriesTag" },
        ]);
      } else {
        setSeries_on(series_on.filter((item) => item.id !== value));
      }
    }
  };

  function loadListdata() {
    let tempCate = [];
    let tempSubj = [];
    let tempCourse = [];
    let tempMedium = [];
    let tempSeries = [];
    category_on.map((obj) => {
      tempCate.push(Number(obj.id));
    });
    course_on.map((obj) => {
      tempCourse.push(Number(obj.id));
    });
    subject_on.map((obj) => {
      tempSubj.push(Number(obj.id));
    });
    medium_on.map((obj) => {
      tempMedium.push(Number(obj.id));
    });
    series_on.map((obj) => {
      tempSeries.push(obj.id);
    });
    let statusFilter = {
      book_name: searchTerm.length > 0 ? searchTerm : "",
      category: category_on.length > 0 ? tempCate : "",
      course: course_on.length > 0 ? tempCourse : "",
      subject: subject_on.length > 0 ? tempSubj : "",
      medium: medium_on.length > 0 ? tempMedium : "",
      book_type: series_on.length > 0 ? tempSeries.map(Number) : "",
      start_date: appOns.length > 0 ? appOns[0].fdate : "",
      end_date: appOns.length > 0 ? appOns[0].edate : "",
      start_range_mrp: initialfields.fromPrice || "",
      end_range_mrp: initialfields.toPrice || "",
    };
    setIsLoading(true);
    AxiosInstance.post("/api/book/preorder_list", statusFilter)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          setCurrentPage(1);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            book_title: item.book_title,
            category_name: item.category_name,
            group_course_name: item.group_course_name,
            subject_name: item.subject_name,
            medium: item.medium,
            series_name: item.series_name,
            order_count: item.order_count,
            purchase_count: item.purchase_count,
            expected_date: moment(item.expected_date).format("DD/MM/YYYY"),
            price: item.price,
            offer_percentage: item.offer_percentage,
            final_amount: item.final_amount,
            isbn_no: item.isbn_no,
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
          getAPCSData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }

  function getAPCSData(data) {
    if (data.length > 0) {
      const seenCourseIds = new Set();
      const seenSubjectIds = new Set();
      const CourseDatas = data
        .filter((es) => {
          if (!es.group_course_name || seenCourseIds.has(es.group_course_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenCourseIds.add(es.group_course_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          course_name: es.group_course_name,
          course_id: es.group_course_id,
        }));

      setCourseId(CourseDatas);
      setCourseIds(CourseDatas);
      const SubjectDatas = data
        .filter((es) => {
          if (!es.subject_name || seenSubjectIds.has(es.subject_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenSubjectIds.add(es.subject_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          subject_name: es.subject_name,
          subject_id: es.subject_id,
        }));

      setSubjectId(SubjectDatas);
      setSubjectIds(SubjectDatas);
    }
  }

  function loadChipdata(price = initialfields) {
    let tempArr = [];

    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    if (price.fromPrice || price.toPrice) {
      tempArr.push({
        name: `  ${price.fromPrice || 0} - ${price.toPrice || 0}`,
        value: `MRP`,
        type: "price",
      });
    }
    filterAvalible_to_user.map((obj) => {
      tempArr.push(obj);
    });
    filterCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterCourse.map((obj) => {
      tempArr.push(obj);
    });
    filterSubject.map((obj) => {
      tempArr.push(obj);
    });
    filterMedium.map((obj) => {
      tempArr.push(obj);
    });
    filterSeries.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyeds.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }

  function updateStateData() {
    filterAvalible_to_user = available_to_user;
    filterCategory = category_on;
    filterCourse = course_on;
    filterSubject = subject_on;
    filterMedium = medium_on;
    filterSeries = series_on;
    filterApplyeds = appOns;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "available_to_user") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        available_to_user: false,
      });
    } else if (name === "price") {
      loadChipdata();
      // let tempArr = [];
      // if (initialfields.fromDate || initialfields.toDate) {
      //   tempArr.push({
      //     name: `${initialfields.fromDate || 0} - ${initialfields.toDate || 0}`,
      //     value: `MRP`,
      //     type: "price"
      //   });
      // }
      // setUpdateChipData(tempArr); loadListdata();
      setIsOpen({
        ...isOpen,
        price: false,
      });
    } else if (name === "category") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "course") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        course: false,
      });
    } else if (name === "subject") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    } else if (name === "medium") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    } else if (name === "seriesTag") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        seriesTag: false,
      });
    } else if (name === "appliedOns") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    }
  };

  const handleClear = (name) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      available_to_user: false,
      category: false,
      course: false,
      subject: false,
      medium: false,
      seriesTag: false,
    });
    if (name === "available_to_user") {
      updateStateData();
      setAvailable_to_user([]);
      filterAvalible_to_user = [];
    } else if (name === "category") {
      updateStateData();
      setCategory_on([]);
      filterCategory = [];
    } else if (name === "course") {
      updateStateData();
      setCourse_on([]);
      filterCourse = [];
    } else if (name === "subject") {
      updateStateData();
      setSubject_on([]);
      filterSubject = [];
    } else if (name === "seriesTag") {
      updateStateData();
      setSeries_on([]);
      filterSubject = [];
    } else if (name === "medium") {
      updateStateData();
      setMedium_on([]);
      filterMedium = [];
    } else if (name === "price") {
      updateStateData();
      setInitialfields({});
      setIsOpen({
        ...isOpen,
        price: false,
      });
    } else if (name === "appliedOns") {
      updateStateData();
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    }
    setTimeout(() => {
      loadChipdata();
    }, 500);
  };

  const handleFilter = (e, boxName) => {
    if (boxName === "available_to_user") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        available_to_user: !prevState.available_to_user, // Toggle the value
        category: false,
        visible_to_user: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
        seriesTag: false,
      }));
      setAvailable_to_user(
        updateChipData.filter((ui) => ui.type === "available_to_user")
      );
    } else if (boxName === "price") {
      setIsOpen((prevState) => ({
        ...prevState,
        seriesTag: false,
        subject: false,
        course: false,
        category: false,
        is_visible: false,
        publisher: false,
        author: false,
        is_combo_offer: false,
        is_free_book: false,
        price: !prevState.price,
        availableToUser: false,
        medium: false,
      }));
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        category: !prevState.category, // Toggle the value
        visible_to_user: false,
        publisher: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
        seriesTag: false,
      }));
      setCategory_on(updateChipData.filter((ui) => ui.type === "category"));
    } else if (boxName === "course") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        course: !prevState.course, // Toggle the value
        category: false,
        visible_to_user: false,
        publisher: false,
        subject: false,
        medium: false,
        author: false,
        seriesTag: false,
      }));
      setCourse_on(updateChipData.filter((ui) => ui.type === "course"));
    } else if (boxName === "subject") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        subject: !prevState.subject, // Toggle the value
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        medium: false,
        author: false,
        seriesTag: false,
      }));
      setSubject_on(updateChipData.filter((ui) => ui.type === "subject"));
    } else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        medium: !prevState.medium, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
        seriesTag: false,
      }));
      setMedium_on(updateChipData.filter((ui) => ui.type === "medium"));
    } else if (boxName === "seriesTag") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        seriesTag: !prevState.seriesTag, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
        medium: false,
      }));
      setSeries_on(updateChipData.filter((ui) => ui.type === "seriesTag"));
    } else if (boxName === "appliedOn") {
      setIsOpen((prevState) => ({
        seriesTag: false,
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
        is_ebook: false,
        is_free_book: false,
        medium: false,
        startDates: !prevState.startDates,
      }));
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;

      if (
        filterRef_category.current &&
        !filterRef_category.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "category"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "category"
            );
            setCategory_on(updatedCategory);
          } else {
            setCategory_on([]);
          }
          setIsOpen((prev) => ({ ...prev, category: false }));
        }
      }
      if (
        filterRef_mrp.current &&
        !filterRef_mrp.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "price"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "price"
            );
            // alert("1")
            const [fromPrice, toPrice] = updatedAuthor[0].name
              .split(" - ")
              .map((val) => val.trim());

            setInitialfields({ fromPrice, toPrice });
          } else {
            // alert("2")

            setInitialfields({ fromPrice: "", toPrice: "" });
          }
          setIsOpen((prev) => ({ ...prev, price: false }));
        }
      }
      // if (
      //   filterLastRef.current &&
      //   !filterLastRef.current.contains(event.target)
      // ) {
      //   const mismatchedDay = updateChipData.find(
      //     (chipItem) => chipItem.Days && chipItem.Days === appDatas.Days
      //   );
      //   if (mismatchedDay) {
      //     setAppDatas({
      //       FDate: "",
      //       TDate: "",
      //       Days: mismatchedDay.Days,
      //     });
      //     setAppOns([
      //       {
      //         name: mismatchedDay.name || "",
      //         FDate: "",
      //         TDate: "",
      //         Days: mismatchedDay.Days,
      //       },
      //     ]);
      //   } else {
      //     const mismatchedDate = updateChipData.find(
      //       (chipItem) =>
      //         chipItem.fdate === appDatas.FDate &&
      //         chipItem.edate === appDatas.TDate
      //     );
      //     if (mismatchedDate) {
      //       setAppDatas((prev) => ({
      //         ...prev,
      //         FDate: mismatchedDate.fdate,
      //         TDate: mismatchedDate.edate,
      //         Days: "",
      //       }));
      //       setAppOns([
      //         {
      //           name:
      //             mismatchedDate.name ||
      //             `${mismatchedDate.fdate} - ${mismatchedDate.edate}`,
      //           FDate: mismatchedDate.fdate,
      //           TDate: mismatchedDate.edate,
      //           Days: "",
      //         },
      //       ]);
      //     } else {
      //       setAppDatas({
      //         FDate: "",
      //         TDate: "",
      //         Days: "",
      //       });
      //       setAppOns([]);
      //     }
      //   }
      //   setIsOpen((prev) => ({ ...prev, startDates: false }));
      // }
      if (
        filterRef_course.current &&
        !filterRef_course.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "course"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "course"
            );
            setCourse_on(updatedCategory);
          } else {
            setCourse_on([]);
          }
          setIsOpen((prev) => ({ ...prev, course: false }));
        }
      }
      if (
        filterRef_subject.current &&
        !filterRef_subject.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "subject"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "subject"
            );
            setSubject_on(updatedCategory);
          } else {
            setSubject_on([]);
          }
          setIsOpen((prev) => ({ ...prev, subject: false }));
        }
      }
      if (
        filterRef_medium.current &&
        !filterRef_medium.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "medium"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "medium"
            );
            setMedium_on(updatedCategory);
          } else {
            setMedium_on([]);
          }
          setIsOpen((prev) => ({ ...prev, medium: false }));
        }
      }

      if (
        filterRef_series.current &&
        !filterRef_series.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "seriesTag"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "seriesTag"
            );
            setSeries_on(updatedCategory);
          } else {
            setSeries_on([]);
          }
          setIsOpen((prev) => ({ ...prev, seriesTag: false }));
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    updateChipData,
    series_on,
    category_on,
    course_on,
    subject_on,
    medium_on,
    initialfields,
  ]);

  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    let shouldReloadChipData = true;
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "available_to_user") {
      setAvailable_to_user(
        available_to_user.filter((item) => item.id !== chipToDelete.id)
      );
      filterAvalible_to_user = available_to_user.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "category") {
      setCategory_on(category_on.filter((item) => item.id !== chipToDelete.id));
      filterCategory = category_on.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "price") {
      setInitialfields({ fromPrice: "", toPrice: "" });
      setUpdateChipData((prevChips) =>
        prevChips.filter((chip) => chip.type !== "price")
      );
      shouldReloadChipData = false;
    } else if (chipToDelete.type === "course") {
      setCourse_on(course_on.filter((item) => item.id !== chipToDelete.id));
      filterCourse = course_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "subject") {
      setSubject_on(subject_on.filter((item) => item.id !== chipToDelete.id));
      filterSubject = subject_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "medium") {
      setMedium_on(medium_on.filter((item) => item.id !== chipToDelete.id));
      filterMedium = medium_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "seriesTag") {
      setSeries_on(series_on.filter((item) => item.id !== chipToDelete.id));
      filterSeries = series_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "dayRanges") {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
    } else {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
    }
    if (shouldReloadChipData) {
      loadChipdata();
    }
  };
  const handleAllClear = () => {
    setMedium_on([]);
    setSubject_on([]);
    setCourse_on([]);
    setCategory_on([]);
    setSearchTerm([]);
    setSeries_on([]);
    setInitialfields({});
    setUpdateChipData([]);
    setAppOns([]);
    setAppDatas({
      FDate: "",
      TDate: "",
      Days: "",
    });
  };
  const dispatch = useDispatch();
  const handleNavigate = (bookIds, ids) => {
    const formattedAppOns = appOns.map((item) => ({
      name:
        item.name ||
        (item.FDate && item.TDate ? `${item.FDate} - ${item.TDate}` : ""),
      fdate: item.fdate || item.FDate,
      edate: item.edate || item.TDate,
      type: item.type || "dateRange",
    }));
    // dispatch(
    //   setBookFilters({
    //     category: category_on,
    //     course: course_on,
    //     subject: subject_on,
    //     medium: medium_on,
    //     seriesTag: series_on,
    //     searchTerm: searchTerm,
    //     date: formattedAppOns,
    //     price: initialfields,
    //   })
    // );
    navigate(`/studyMaterials/Books/ViewPreOrder/${bookIds}/${ids}`, {
      state: {
        REDUXKEY: 1,
        CATEGORY: category_on,
        COURSE: course_on,
        SUBJECT: subject_on,
        MEDIUM: medium_on,
        SERIES: series_on,
        SEARCH: searchTerm,
        DATE: formattedAppOns,
        PRICE: initialfields,
      },
    });
  };

  const generatePDF = () => {
    const headers = [
      "Pre Order Name",
      "Course",
      "Book Series",
      "Pre Order Count",
      "Purchase Count",
      "Expected by Date",
    ];

    const rows = csvData.map((item, index) => [
      item.book_title ?? "-",
      item.group_course_name ?? "-",
      item.series_name ?? "-",
      item.order_count ?? "-",
      item.purchase_count ?? "-",
      item.expected_date ?? "-",
    ]);

    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Preorder Data",
          headers,
          rows,
          filename: "Preorder.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const handleAppliedOns = (e) => {
    const { name, value, checked } = e.target;
    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "", // Reset Days when FDate or TDate is changed
        };
        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOns([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRanges",
              Days: "",
            },
          ]);
        } else {
          setAppOns([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRanges",
              Days: "",
            },
          ]);
        }
        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        // Set Days and reset FDate/TDate
        setAppDatas({
          FDate: "",
          TDate: "",
          Days: value,
        });
        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";
        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }
        setAppOns([
          {
            name: label,
            fdate,
            edate,
            type: "dayRanges",
            Days: value,
          },
        ]);
      }
    }
  };
  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };
        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOns([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Pre-Order Book Name", key: "book_title" },
    { label: "Category", key: "category_name" },
    { label: "Course", key: "group_course_name" },
    { label: "Subject", key: "subject_name" },
    { label: "Medium", key: "medium" },
    { label: "Book Series", key: "series_name" },
    { label: "Pre-Order Count", key: "order_count" },
    { label: "Purchase Count", key: "purchase_count" },
    { label: "Expected by Date", key: "expected_date" },
    { label: "MRP", key: "price" },
    { label: "Offer", key: "offer_percentage" },
    { label: "Final Price", key: "final_amount" },
    { label: "ISBN No", key: "isbn_no" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={` container-fluid BathDet  global_container p-0`}>
      {/* ---------------------------------------------------------------- */}
      <div className="row mx-0 ">
        <div className="col-lg-3 col-md-3 col-sm-12 mb-3 col-xs-12 px-0">
          <div class={ListInfo.searchInputSec}>
            <input
              className={`${ListInfo.searchInput} w-100`}
              type="text"
              placeholder="Search by Pre-Order Book Name"
              name="search_book_title"
              onKeyDown={handleSearch}
              ref={txtBSearch}
            />
            <Search
              onClick={handleSearchFocus}
              className={`${ListInfo.ListsearchIcon}`}
            />
          </div>
        </div>

        <div className="col-md-9  col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <CustomDownloadButton
                csvListData={csvData?.length > 0 ? csvData : ""}
                headers={csvHeaders}
                iconName=" file_download "
                filename={"PreOrder.csv"}
                csvName="  Download as CSV"
              />
            </li>
            <li class="ListBtnItems primaryButton" onClick={generatePDF}>
              <span className="material-icons me-1 align-middle text-white">
                file_download
              </span>
              Download as PDF
            </li>
            <li class="ListBtnItems">
              <Link
                onClick={handleClick}
                to="javascript:void(0)"
                className="primaryButton "
                variant="primary"
              >
                Create New Pre-Order
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {updateChipData?.length > 0 ? (
        <div className="row mx-0">
          <div className="col-md-12 px-0 col-sm-12 col-xs-12 paperil_global">
            <Paper
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData.map((data, index) => {
                let icon;
                return (
                  <ListItem key={index}>
                    <Chip
                      icon={icon}
                      label={
                        <>
                          <span className={ListInfo.BoldTyText}>
                            {data.type === "price"
                              ? `Price: ${data.name}`
                              : data.name}
                          </span>
                        </>
                      }
                      onDelete={handleDelete(data, index)}
                    />
                  </ListItem>
                );
              })}
              <ListItem className="clearAll_list">
                <a
                  className="clearAll_listItem"
                  href="javascript:void(0)"
                  onClick={handleAllClear}
                >
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        // No chips to show
        <div></div>
      )}
      <div className="row mx-0 mt-2">
        <div
          className={`col-md-12 ${ListInfo.table_responsive_padding} table-responsive tableMinHeight px-0 `}
        >
          <table className="table" id="tableListHeader">
            <thead>
              <tr>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "serialNumber")}
                    className="textHead_th"
                  >
                    S.No.
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "serialNumber")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "book_title")}
                    className="textHead_th"
                  >
                    Pre-Order Book Name
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "book_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterRef_category}
                >
                  <span
                    onClick={(e) => handleSort(e, "category_name")}
                    className="textHead_th"
                  >
                    Category
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "category_name")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                  <span
                    className={`textHead_th align-middle material-icons ${
                      category_on.length > 0 || isOpen.category
                        ? ListInfo.active_icons_book
                        : ""
                    } `} // Change here
                    onClick={(e) => handleFilter(e, "category")}
                  >
                    filter_list
                  </span>
                  {isOpen.category && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            {categoryId.map((el) => (
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.name}
                                  value={el.id}
                                  id={el.name}
                                  checked={category_on.some((element) => {
                                    if (element.id == el.id) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, el.name, "category")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={el.name}
                                >
                                  {el.name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("category")}
                              className="secondaryButton "
                            >
                              Clear
                            </Link>
                            <li className="ListBtnItems">
                              <Link
                                disabled={
                                  category_on.length === 0 ? true : false
                                }
                                onClick={() => handleApplyFilter("category")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterRef_course}
                >
                  <span
                    onClick={(e) => handleSort(e, "group_course_name")}
                    className="textHead_th"
                  >
                    Course
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "group_course_name")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                  <span
                    className={`textHead_th align-middle material-icons ${
                      course_on.length > 0 || isOpen.course
                        ? ListInfo.active_icons_book
                        : ""
                    } `} // Change here
                    onClick={(e) => handleFilter(e, "course")}
                  >
                    filter_list
                  </span>
                  {isOpen.course && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li
                              className={`filterListData ${ListInfo.searchInputSec}`}
                            >
                              <input
                                className={`${ListInfo.searchInput} w-100`}
                                type="text"
                                placeholder="Search by course"
                                name="search_book_title"
                                onKeyDown={(e) =>
                                  handleFilterCourseSearch(e, "course")
                                }
                                ref={txtBSearch_course}
                              />
                              <Search
                                onClick={(e) =>
                                  handleFilterSearchFocus("course")
                                }
                                className={`${ListInfo.ListsearchIcon}`}
                              />
                            </li>
                            {courseIds.map((el) => (
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.course_name}
                                  value={el.course_id}
                                  id={el.course_name}
                                  checked={course_on.some((element) => {
                                    if (element.id == el.course_id) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      el.course_name,
                                      "course"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={el.course_name}
                                >
                                  {el.course_name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("course")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={course_on.length === 0 ? true : false}
                                onClick={() => handleApplyFilter("course")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterRef_subject}
                >
                  <span
                    onClick={(e) => handleSort(e, "subject_name")}
                    className="textHead_th"
                  >
                    Subject
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "subject_name")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                  <span
                    className={`textHead_th align-middle material-icons ${
                      subject_on.length > 0 || isOpen.subject
                        ? ListInfo.active_icons_book
                        : ""
                    } `} // Change here
                    onClick={(e) => handleFilter(e, "subject")}
                  >
                    filter_list
                  </span>
                  {isOpen.subject && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li
                              className={`filterListData ${ListInfo.searchInputSec}`}
                            >
                              <input
                                className={`${ListInfo.searchInput} w-100`}
                                type="text"
                                placeholder="Search by subject"
                                name="search_book_title"
                                onKeyDown={(e) =>
                                  handleFilterCourseSearch(e, "subject")
                                }
                                ref={txtBSearch_subj}
                              />
                              <Search
                                onClick={() =>
                                  handleFilterSearchFocus("subject")
                                }
                                className={`${ListInfo.ListsearchIcon}`}
                              />
                            </li>
                            {subjectIds.map((el) => (
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.subject_name}
                                  value={el.subject_id}
                                  id={el.subject_name}
                                  checked={subject_on.some((element) => {
                                    if (element.id == el.subject_id) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      el.subject_name,
                                      "subject"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={el.subject_name}
                                >
                                  {el.subject_name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("subject")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={
                                  subject_on.length === 0 ? true : false
                                }
                                onClick={() => handleApplyFilter("subject")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterRef_medium}
                >
                  <span
                    onClick={(e) => handleSort(e, "medium")}
                    className="textHead_th"
                  >
                    Medium
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "medium")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                  <span
                    className={`textHead_th align-middle material-icons ${
                      medium_on.length > 0 || isOpen.medium
                        ? ListInfo.active_icons_book
                        : ""
                    } `} // Change here
                    onClick={(e) => handleFilter(e, "medium")}
                  >
                    filter_list
                  </span>
                  {isOpen.medium && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Tamil"}
                                value={"0"}
                                checked={medium_on.some((element) => {
                                  if (element.id == "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"medium_tamil"}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "medium", "medium")
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"medium_tamil"}
                              >
                                Tamil
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"English"}
                                value={"1"}
                                checked={medium_on.some((element) => {
                                  if (element.id == "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"medium_english"}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "medium", "medium")
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"medium_english"}
                              >
                                English
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Both"}
                                value={"2"}
                                checked={medium_on.some((element) => {
                                  if (element.id == "2") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Both"}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "medium", "medium")
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"Both"}
                              >
                                Both
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("medium")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={medium_on.length === 0 ? true : false}
                                onClick={() => handleApplyFilter("medium")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterRef_series}
                >
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "seriesTag")}
                  >
                    Book Series
                  </span>
                  <span
                    className={`textHead_th material-icons align-middle`}
                    onClick={(e) => handleSort(e, "seriesTag")}
                  >
                    import_export{" "}
                  </span>
                  <span
                    className={`textHead_th align-middle material-icons ${
                      series_on.length > 0 || isOpen.seriesTag
                        ? ListInfo.active_icons_book
                        : ""
                    } `} // Change here
                    onClick={(e) => handleFilter(e, "seriesTag")}
                  >
                    filter_list
                  </span>
                  {isOpen.seriesTag && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            {Tagsitems.map((el) => (
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.tag_name}
                                  value={el.tag_id}
                                  id={el.tag_name}
                                  checked={series_on.some((element) => {
                                    if (element.id == el.tag_id) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      el.tag_name,
                                      "seriesTag"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={el.tag_name}
                                >
                                  {el.tag_name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("seriesTag")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={series_on.length === 0 ? true : false}
                                onClick={() => handleApplyFilter("seriesTag")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        ref={filterRef_medium}
                        className={`${ListInfo.overlayBookFilter} ${
                          isOpen.medium ? "active" : ""
                        }`}
                      ></div>
                    </>
                  )}
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <div class={ListInfo.thcontent}>
                    <span
                      onClick={(e) => handleSort(e, "order_count")}
                      class="textHead_th"
                    >
                      Pre-Order <br /> Count
                    </span>
                    <div class={ListInfo.iconcontainer}>
                      <span
                        onClick={(e) => handleSort(e, "order_count")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </div>
                  </div>
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <div class={ListInfo.thcontent}>
                    <span
                      onClick={(e) => handleSort(e, "purchase_count")}
                      class="textHead_th"
                    >
                      Purchase <br /> Count
                    </span>
                    <div class={ListInfo.iconcontainer}>
                      <span
                        onClick={(e) => handleSort(e, "purchase_count")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </div>
                  </div>
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <div class={ListInfo.thcontent}>
                    <span
                      onClick={(e) => handleSort(e, "expected_date")}
                      class="textHead_th"
                    >
                      Expected <br /> by Date
                    </span>
                    <div class={ListInfo.iconcontainer}>
                      <span
                        onClick={(e) => handleSort(e, "expected_date")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </div>
                  </div>
                </th>
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterRef_mrp}
                >
                  <span
                    onClick={(e) => handleSort(e, "price")}
                    className="textHead_th"
                  >
                    MRP
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "price")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                  <span
                    className={`textHead_th align-middle material-icons ${
                      initialfields.fromPrice ||
                      initialfields.toPrice ||
                      isOpen.price
                        ? ListInfo.active_icons_book
                        : ""
                    } `} // Change here
                    onClick={(e) => handleFilter(e, "price")}
                  >
                    filter_list
                  </span>
                  {isOpen.price === true && (
                    <div className="filterBoxs p-1 mt-3">
                      <div className="row ">
                        <div className="col-md-12">
                          <div>
                            <div>
                              <label
                                for="bookName"
                                class="form-label confirm_value "
                              >
                                From
                              </label>
                            </div>
                            <input
                              class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                              type="number"
                              id="fromPrice"
                              name="fromPrice"
                              onWheel={(e) => e.target.blur()}
                              placeholder="Enter the from price"
                              value={initialfields.fromPrice}
                              onChange={handleChange}
                            />
                          </div>
                          <div>
                            <div>
                              <label
                                for="bookName"
                                class="form-label confirm_value "
                              >
                                To
                              </label>
                            </div>
                            <input
                              class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                              type="number"
                              id="toPrice"
                              name="toPrice"
                              onWheel={(e) => e.target.blur()}
                              placeholder="Enter the to price"
                              value={initialfields.toPrice}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("price")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("price")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "offer_percentage")}
                    className="textHead_th"
                  >
                    Offer %
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "offer_percentage")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <div class={ListInfo.thcontent}>
                    <span
                      onClick={(e) => handleSort(e, "final_amount")}
                      class="textHead_th"
                    >
                      Final <br /> Price
                    </span>
                    <div class={ListInfo.iconcontainer}>
                      <span
                        onClick={(e) => handleSort(e, "final_amount")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </div>
                  </div>
                </th>{" "}
                <th
                  id="th"
                  className={ListInfo.tableThPadding}
                  ref={filterLastRef}
                >
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "created_dt")}
                  >
                    {" "}
                    Created Date
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "created_dt")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    onClick={(e) => handleFilter(e, "appliedOn")}
                    class={` align-middle material-icons ${
                      (appDatas &&
                        Object.entries(appDatas).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                      isOpen.startDates
                        ? ListInfo.active_icons_book
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.startDates === true && (
                    <div className="filterBoxs_testlist container mt-2   p-1">
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                                                                                                 /> */}
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              class={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appDatas.FDate}
                              txtAdMDob={fDatePickerRef}
                              // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                                                                                                 /> */}
                            <DatePickerSample
                              class={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appDatas.TDate}
                              txtAdMDob={tDatePickerRef}
                              minDate={appDatas.FDate}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="row mt-2">
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              id="Today"
                              value="Today"
                              checked={appDatas.Days === "Today"}
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Today"
                              htmlFor="Today"
                              style={{ fontWeight: "bold" }}
                            >
                              Today
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Yesterday"
                              checked={appDatas.Days === "Yesterday"}
                              id="Yesterday"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Yesterday"
                              htmlFor="Yesterday"
                              style={{ fontWeight: "bold" }}
                            >
                              Yesterday
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tweek"
                              checked={appDatas.Days === "Tweek"}
                              id="Tweek"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tweek"
                              htmlFor="Tweek"
                              style={{ fontWeight: "bold" }}
                            >
                              This week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Lweek"
                              checked={appDatas.Days === "Lweek"}
                              id="Lweek"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lweek"
                              htmlFor="Lweek"
                              style={{ fontWeight: "bold" }}
                            >
                              Last week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tmonth"
                              checked={appDatas.Days === "Tmonth"}
                              id="Tmonth"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tmonth"
                              htmlFor="Tmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              This month
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              checked={appDatas.Days === "Lmonth"}
                              value="Lmonth"
                              id="Lmonth"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lmonth"
                              htmlFor="Lmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              Last month
                            </label>
                          </div>
                        </div>
                      </div> */}
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("appliedOns")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("appliedOns")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th" className={ListInfo.tableThPadding}>
                  <span className="textHead_th">Action</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData?.length === 0 ? (
                <tr>
                  <td colspan="15" style={{ textAlign: "center" }}>
                    No records to display
                  </td>
                </tr>
              ) : (
                currentData?.map((kl, ind) => (
                  <tr key={ind}>
                    <td id="td">{kl.serialNumber}</td>
                    <td id="td">
                      <span
                        title={kl.book_title}
                        className={ListInfo.ellipsisText}
                      >
                        {kl.book_title}
                      </span>
                    </td>

                    <td id="td">{kl.category_name ? kl.category_name : "_"}</td>
                    <td id="td">
                      <span
                        title={kl.group_course_name}
                        className={ListInfo.ellipsisText}
                      >
                        {kl.group_course_name ? kl.group_course_name : "_"}
                      </span>
                    </td>
                    <td id="td">
                      <span
                        title={kl.subject_name}
                        className={ListInfo.ellipsisText}
                      >
                        {kl.subject_name ? kl.subject_name : "_"}
                      </span>
                    </td>
                    <td id="td">{kl.medium ? kl.medium : "_"}</td>
                    <td id="td">{kl.series_name || "_"}</td>
                    <td id="td">{kl.order_count ? kl.order_count : "_"}</td>
                    <td id="td">
                      {kl.purchase_count !== null ? kl.purchase_count : "_"}
                    </td>
                    <td id="td">
                      {kl.expected_date
                        ? moment(kl.expected_date).format("DD/MM/YYYY")
                        : "_"}
                    </td>
                    <td id="td">{kl.price ? kl.price : "0"}</td>
                    <td id="td">
                      {kl.offer_percentage ? kl.offer_percentage : "0"}
                    </td>
                    <td id="td">{kl.final_amount ? kl.final_amount : "0"}</td>
                    <td id="td">
                      {moment(kl.created_dt).utc().format("DD/MM/YYYY")}
                    </td>
                    <td id="td">
                      <img
                        src={ViewIcon}
                        className={ListInfo.cursor_pointer}
                        onClick={() => handleNavigate(kl.book_id, kl.id)}
                        alt="view icon"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="row mt-2">
        <Pagination
          rowsPerPage={rowsPerPage}
          handlePageCount={handlePageCount}
          startPage={
            updateListData && updateListData?.length > 0
              ? currentPage * rowsPerPage + 1 - rowsPerPage
              : 0
          }
          endPage={
            updateListData && updateListData?.length > 0
              ? updateListData?.length < currentPage * rowsPerPage
                ? updateListData?.length
                : currentPage * rowsPerPage
              : 0
          }
          totalRecords={
            updateListData && updateListData?.length > 0
              ? updateListData?.length
              : 0
          }
          handlePrev={(e) => handlePrev(currentPage - 1)}
          currentPrevPage={currentPage === 1}
          prevButton={`${ListInfo.prev_buttonViewAllbook} ${ListInfo.materialIconsRightAndLeft} me-2`}
          handleNext={() => handleNext(currentPage + 1)}
          currentNextPage={totalPages == 0 || currentPage === totalPages}
        />
      </div>
    </div>
  );
}
